const useScrollPosition = () => {
  const scrollPositionY = ref(0)
  const isPageScrolled = computed(() => scrollPositionY.value > 0)

  const onScroll = () => {
    scrollPositionY.value = window.scrollY
  }

  onMounted(() => {
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
  })

  return {
    scrollPositionY,
    isPageScrolled,
  }
}

export default useScrollPosition
